module.exports = __webpack_public_path__ + "fonts/MyriadPro-SemiboldIt.51e93f5.ttf";